export default {
  state: {
    prescription: undefined,
    selectedTreatments: undefined,
  },
  mutations: {
    nav(state, payload) {
      state.prescription = payload.prescription;
      state.selectedTreatments = payload.selectedTreatments;
    },
    clear(state) {
      state.prescription = undefined;
      state.selection = undefined;
    },
  },
  getters: {
    prescription(state) {
      return state.prescription;
    },
    selectedTreatments(state) {
      return state.selectedTreatments;
    },
  },
};
